import React, { Component } from "react";
import './quemSomos.css';


export default class QuemSomos extends Component{


    /**
     * This method render the information with HTML code
     * @returns Return page information inside HTML
     */
    render(){
        return(
            <div>

                <h1>Sobre Nós</h1>

                <div className="aboutAuthor">
                    <p>Trabalho realizado por <strong>Miguel Rosa</strong> (Nº 6219).</p>
                </div>

                <div className="aboutSchool">
                    <ul>
                        <li><strong>Disciplina:</strong> Tecnologias Web e Ambientes Móveis</li>
                        <li><strong>Curso:</strong> Licenciatura em Engenharia Informática</li>
                        <li><strong>Escola:</strong> Instituto Politécnico de Beja - Escola Superior de Tecnologia e Gestão</li>
                    </ul>
                </div>

                <div className="aboutValidation">
                    <p>O HTML deste projeto foi validado por <a href="https://validator.w3.org/" target="_blank" rel="noopener noreferrer">W3C Validator</a>.</p>
                    <p>Acessibilidade validada por <a href="http://accessmonitor.acessibilidade.gov.pt/amp/" target="_blank" rel="noopener noreferrer">Access Monitor Plus</a>.</p>
                </div>


            </div>
        );
    }

}
